import React, { useEffect, useMemo, useState } from "react";
import withTable from "HOC/withTable/withTable";
import { MaterialReactTable } from "material-react-table";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getApprovedUsersRequestAction } from "./../../../../../redux/actions/customerActions";
import CustomTable from "components/CustomTable";
import { GET_APPROVED_USERS } from "config/apiRoutes";
// --------------------------------------------------------------------------------
const ApprovedUsers = ({ data, renderTopToolbar }) => {
  const dispatch = useDispatch();

  const { approvedUsers } = useSelector((state) => ({
    approvedUsers: state.customer.approvedUsers,
  }));
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  useEffect(() => {
    dispatch(
      getApprovedUsersRequestAction({
        limit: pagination.pageSize,
        offset: pagination.pageIndex + 1,
      })
    );
  }, [dispatch, pagination.pageIndex, pagination.pageSize]);

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => `${row.firstName} ${row.lastName}`,
        header: "User's Full Name",
        size: 150,
        Cell: ({ cell, row }) => (
          <Link to={`/users/pending-users/${row.original.id}`} target="_blank">
            {cell.getValue()}
          </Link>
        ),
      },
      {
        accessorKey: "agent",
        header: "Agent",
        size: 150,
      },
      {
        accessorKey: "email", //normal accessorKey
        header: "Email",
        size: 200,
        Cell: ({ cell, row }) => {
          return row.original.pepStatus == "starter" ? (
            <Link to={`/users/pending-users/${row.original.id}`}>
              {cell.getValue()}
            </Link>
          ) : (
            <span>{cell.getValue()}</span>
          );
        },
      },
      // {
      //   accessorKey: "email", //normal accessorKey
      //   header: "Email",
      //   size: 200,
      //   Cell: ({ cell, row }) => (
      //     <Link to={`/users/pending-users/${row.original.id}`}>
      //       {cell.getValue()}
      //     </Link>
      //   ),
      // },
      {
        accessorKey: "country_code",
        header: "Mobile Country Code",
        size: 150,
      },
      {
        accessorKey: "mobile",
        header: "Mobile",
        size: 150,
      },
      {
        accessorKey: "registerTime",
        header: "Register Time",
        size: 150,
      },
    ],
    []
  );

  return (
    <CustomTable
      title="Approved Users"
      data={approvedUsers.records}
      columns={columns}
      onPaginationChange={setPagination}
      state={{ pagination, loading: false }}
      rowCount={approvedUsers.count}
    />
  );
};

export default ApprovedUsers;
